var map = {
	"./texgyreadventor-bold.woff": 6643,
	"./texgyreadventor-bolditalic.woff": 8991,
	"./texgyreadventor-italic.woff": 1192,
	"./texgyreadventor-regular.woff": 8900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5674;